import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "vendedores",
    "vendedores",
    "EditarUsuarioForm",
    "/vendedores",
);

export default handleActions(reducers, initialState);
